var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGhostFrightened(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9721 47.0382L105.046 46.8782L128.615 146.152L20.9229 146.38L45.1136 114.995L28.9721 47.0382Z",
    fill: "#B143FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.147 72.6444L98.5105 57.3459L88.2275 57.3705L91.8582 72.669L102.147 72.6444Z",
    fill: "#FFEC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5321 57.5059L75.2428 57.5305L78.8798 72.829L89.1628 72.8044L85.5321 57.5059Z",
    fill: "#FFEC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.68 79.0997L62.0367 79.1859L64.0675 87.7459L65.2982 92.9705L67.9198 104.017L68.8121 107.758L70.0428 112.872L77.4705 117.795L112.855 117.721L103.68 79.0997ZM76.5475 92.9459L95.7167 92.9028L98.3382 103.98L79.169 104.017L76.5475 92.9459Z",
    fill: "#FFEC00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.18 14.1538L110.038 29.3155L129.269 19.0136L121.882 39.4936H139.302L123.508 54.1594L121.414 51.9047L131.467 42.5705H117.502L123.654 25.5121L108.423 33.6716L103.819 21.7564L98.6066 32.1816L95.8545 30.8056L104.18 14.1538Z",
    fill: "#762DAA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostFrightened);
export default __webpack_public_path__ + "static/media/ghost_frightened.b8ad6c61de63ee59f064ce6ec763558e.svg";
export { ForwardRef as ReactComponent };